import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { WidgetProcessStepGroupListComponent } from '../widget-process-step-group-list/widget-process-step-group-list.component';

@Component({
  selector: 'app-formly-process-step-group-list',
  templateUrl: './formly-process-step-group-list.component.html',
  styleUrls: ['./formly-process-step-group-list.component.css'],
  standalone: true,
  imports: [
    WidgetProcessStepGroupListComponent
  ]
})
export class FormlyProcessStepGroupListComponent extends FieldType {

  constructor() {
    super();
  }

}
